import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Plus, Search, Filter } from "lucide-react";
import { toast } from "sonner";
import { Toaster } from "../../components/ui/sonner";
import { OfferCard } from "../../components/OfferCard";
import { OfferForm } from "../../components/OfferForm";
import ModalHeaderStyle from "../../utility/component/styles/modalHeader";
import OfferMaster from "../offer-master";
import { Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import useToken from "antd/es/theme/useToken";
import { selectPrefix } from "../../utility/Redux/profile";
import { selectToken } from "../../utility/Redux/security";
import { GetOfferList } from "../../reports/offerSummery/func";
import AlertModalTwoButton from "../../utility/component/modals/alertWithTwoButton";
import { CallAPIPromise } from "../../billing/common";
// Mock data


export default function NewOfferMaster() {
  const [offers, setOffers] = useState([]);
  const [refresh,setRefresh]= useState(false)
  const [searchQuery, setSearchQuery] = useState("");
  const [filterSection, setFilterSection] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingOffer, setEditingOffer] = useState();
  const [sectionList,setSectionList] =useState([])
  const handleAddOffer = () => {
    setEditingOffer(undefined);
    setIsDialogOpen(true);
  };
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: "",
    msg: "",
    status: false,
    setStatus: "",
    button1: "",
    button1Click: "",
    button2: "",
    button2Click: "",
  });

  const handleEditOffer = (offer) => {
    console.log(offer)
    setEditingOffer(offer);
    setIsDialogOpen(true);
  };

  const handleDeleteOffer = (offer) => {
    setAlertTwoButtonModal({
        ...alertTwoButtonModal,
        status: true,
        title: "Delte Offer",
        msg: "Are you sure to delete this offer",
        button1: "Delete",
        button2:'Cancel',

        button1Click: () => {
          setAlertTwoButtonModal({
            ...alertTwoButtonModal,
            status: false,
          });

       CallAPIPromise('/api/offerMaster/deleteOffer',{
        table_prefix:prefix,
        SERIAL_NO:offer.SERIAL_NO
       }).then(()=>{
        toast.success("Offer Deleted")
       })
       setRefresh(r=>!r)
        },
        button2Click: () => {
            setAlertTwoButtonModal({
              ...alertTwoButtonModal,
              status: false,
            });
  
         
          },
      });
  };

  const handleSubmitOffer = (offer) => {
    if (editingOffer) {
      setOffers((prev) =>
        prev.map((o) => (o.SERIAL_NO === offer.SERIAL_NO ? offer : o))
      );
      toast.success("Offer updated successfully");
    } else {
      const newOffer = {
        ...offer,
        SERIAL_NO: String(offers.length + 1),
        // ICODEs.length + 10,
      };
      setOffers((prev) => [...prev, newOffer]);
      toast.success("Offer created successfully");
    }
    setIsDialogOpen(false);
    setEditingOffer(undefined);
  };

  const filteredOffers = offers.filter((offer) => {
    const matchesSearch =
      offer.ITEMNAME.toLowerCase().includes(searchQuery.toLowerCase()) ||
      offer.ALIAS_CODE.includes(searchQuery);
    
    const matchesSection =
      filterSection === "all" || offer.SECTION_NAME === filterSection;
    
    const isActive =
      new Date(offer.FDATE) <= new Date() && new Date(offer.TDATE) >= new Date();
    const matchesStatus =
      filterStatus === "all" ||
      (filterStatus === "active" && isActive) ||
      (filterStatus === "scheduled" && !isActive);

    return matchesSearch && matchesSection && matchesStatus;
  });

  const activeCount = offers.filter(
    (o) => new Date(o.FDATE) <= new Date() && new Date(o.TDATE) >= new Date()
  ).length;
const dispatch = useDispatch()
const token = useSelector(selectToken)
const prefix = useSelector(selectPrefix)
  useEffect(() => {
    GetOfferList(
      {
        table_prefix: prefix,
        FDATE: "",
        TDATE: "",
      },
      token,
      dispatch,
      setOffers,setSectionList
      )
    }, [refresh]);
  return (
    <div className="h-full  bg-gradient-to-br from-background to-muted/20 overflow-y-auto">
      
      <div className="container mx-auto px-4 py-8 max-w-7xl h-full">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div>
              <div className="text-[25px] font-semibold">Offer Master</div>
              <p className="text-muted-foreground mt-1">
                Manage all your promotional offers in one place
              </p>
            </div>
            <Button onClick={handleAddOffer} size="lg">
              <Plus className="w-5 h-5 mr-2" />
              Create Offer
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-3">
            <div className=" border rounded-lg p-4">
              <div className="text-muted-foreground">Total Offers</div>
              <div className="text-2xl mt-1">{offers.length}</div>
            </div>
            <div className="bg-card border rounded-lg p-4">
              <div className="text-muted-foreground">Active Offers</div>
              <div className="text-2xl text-green-600 mt-1">{activeCount}</div>
            </div>
            <div className="bg-card border rounded-lg p-4">
              <div className="text-muted-foreground">Scheduled</div>
              <div className="text-2xl text-blue-600 mt-1">{offers.length - activeCount}</div>
            </div>
          </div>

          {/* Filters */}
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1">
            <Input
                placeholder="Search by item name or barcode..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className=""
              />
            
            </div>
            <Select value={filterSection} onValueChange={setFilterSection}>
              <SelectTrigger className="w-full sm:w-[200px]">
                <Filter className="w-4 h-4 mr-2" />
                <SelectValue placeholder="All Sections" />
              </SelectTrigger>
              <SelectContent className={'bg-white'}>
                <SelectItem value="all">All Sections</SelectItem>
                {sectionList.map(s=>{
                    return (
                        <SelectItem value={s}>{s}</SelectItem>

                    )
                })}
               
              </SelectContent>
            </Select>
            <Select value={filterStatus} onValueChange={setFilterStatus}>
              <SelectTrigger className="w-full sm:w-[200px]">
                <SelectValue placeholder="All Status" />
              </SelectTrigger>
              <SelectContent className={'bg-white'}>
                <SelectItem value="all">All Status</SelectItem>
                <SelectItem value="active">Active</SelectItem>
                <SelectItem value="scheduled">Scheduled</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        {/* Offers Grid */}
    {/* Offers Grid */}
    <div  className="  pr-2">
    {filteredOffers.length === 0 ? (
      <div className="text-center py-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted mb-4">
          <Search className="w-8 h-8 text-muted-foreground" />
        </div>
        <h3>No offers found</h3>
        <p className="text-muted-foreground mt-2">
          Try adjusting your search or filters
        </p>
      </div>
    ) : (
      <div className="grid grid-cols-1  lg:grid-cols-2 gap-6 pb-4">
        {filteredOffers.map((offer) => (
          <OfferCard
            key={offer.SERIAL_NO}
            offer={offer}
            onEdit={handleEditOffer}
            onDelete={handleDeleteOffer}
          />
        ))}
      </div>
    )}
  </div>


      </div>

      {/* Add/Edit Dialog */}
      <Modal open={isDialogOpen} >
        <div  style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: '80%',
          backgroundColor: "white",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          borderRadius: 8,
          
        }} className="overflow-hidden">
            {isDialogOpen &&<OfferMaster afterSave={()=>{
                setRefresh(r=>!r)
                setIsDialogOpen(false)
            }} isDialogOpen={isDialogOpen} editItem={editingOffer} onClose={()=>{
        setIsDialogOpen(false)
       }}/>}
       

        </div>
      </Modal>
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
    </div>
  );
}
